import React from "react";
import { Link } from "react-router-dom";

const ProjectDetailsLeft = ({ projectInfo }) => {
  if (!projectInfo) return null;

  const {
    liftType,
    tagline,
    passengerSize,
    speed,
    efficiency,
    address,
    phone,
    fax,
    email,
    socialLinks,
    contactImage,
  } = projectInfo;

  return (
    <div className="project-details__left">
      <div className="project-details__information">
        <h3 className="project-details__information-title">{liftType}</h3>
        <ul className="project-details__information-list list-unstyled">
          {/* <li>
            <span>{category}</span>
            <p>{category}</p>
          </li> */}
          <li>
            <span>{tagline}</span>
            {/* <p>{customer}</p> */}
          </li>
          <li>
            <span>{passengerSize}</span>
            {/* <p>{startDate}</p> */}
          </li>
          <li>
            <span>{speed}</span>
            {/* <p>{endDate}</p> */}
          </li>
          <li>
            {/* <span>Rating:</span> */}
            {/* <p> */}
              <span>{efficiency}</span>
              {/* {Array.from({ length: rating }, (_, i) => (
                <i className="icon-star" key={i} />
              ))} */}
            {/* </p> */}
          </li>
        </ul>
        <div className="project-details__social">
          {socialLinks.map((link, index) => (
            <Link
              to={link.url}
              aria-label={link.label}
              key={`${link.url}-${index}`}
            >
              <span className={link.iconClass} />
            </Link>
          ))}
        </div>
      </div>
      {/* Replace contact info list with an image */}
      {contactImage && (
        <div className="project-details__contact-image">
          <img
            src={contactImage}
            alt="Contact Info"
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </div>
      )}
      {/* <ul className="project-details__contact-list list-unstyled">
        <li>
          <div className="icon">
            <span className="icon-location icon-1" />
          </div>
          <div className="content">
            <h3>Address</h3>
            <p>{address}</p>
          </div>
        </li>
        <li>
          <div className="icon">
            <span className="icon-call icon-2" />
          </div>
          <div className="content">
            <h3>Let's Talk</h3>
            <p>
              Phone number: <a href={`tel:${phone}`}>{phone}</a>
            </p>
            <p>
              Fax: <a href={`tel:${fax}`}>{fax}</a>
            </p>
          </div>
        </li>
        <li>
          <div className="icon">
            <span className="icon-envolop icon-3" />
          </div>
          <div className="content">
            <h3>Send us an email</h3>
            <p>
              <a href={`mailto:${email}`}>{email}</a>
            </p>
          </div>
        </li>
      </ul> */}
    </div>
  );
};

export default ProjectDetailsLeft;
